module.exports = __webpack_public_path__ + "img/bastajkorak.199f7e4e.png";